import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/app.config';

bootstrapApplication(App, appConfig).catch((error: unknown) => {
  console.error('Не удалось запустить приложение:', error);
  const fallback = document.getElementById('bootstrap-fallback');
  if (fallback) {
    fallback.textContent =
      'Не удалось запустить приложение. Обновите страницу или обратитесь в поддержку.';
    fallback.classList.add('bootstrap-fallback--error');
  }
});
